import axios from 'axios';

export const getBackendVersion = async (): Promise<string | null> => {
  const response = await axios.get<{ backendVersion?: string }>('health', {
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 12000,
  });
  return typeof response.data.backendVersion === 'string' ? response.data.backendVersion : null;
};
